<template>
    <b-modal v-model="show" title="АГЕНТЛАР" class="bind-agent">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("report.field.agents")}} <span class="red">*</span></label>
                        <v-select v-model="realEstate.createdBy" label="text"
                                  :options="agents"
                                  :filterable="false"
                                  :class="{invalid: $v.realEstate.createdBy.$error}"
                                  @search="onUsersSearch"
                                  @search:focus="onUsersFocus">
                            <template slot="option" slot-scope="option" v-if="option">
                                <div v-html="option.name"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="realEstate && realEstate.createdBy && realEstate.createdBy.name">
                                <div v-html="realEstate.createdBy.name"
                                     @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="btn btn-success float-right" v-if="hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_AGENT') &&
                                            (!realEstate.createdBy || realEstate.createdBy.id)"
                    @click="bindAgent()">
                <i class="fa fa-check"></i>
                {{$t("realEstate.action.bindAgent")}}
            </button>
            <button class="btn btn-default float-right mr-2" @click="show=!show">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {required} from 'vuelidate/lib/validators';
    export default {
        name: "NewRealEstateBindAgentModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                filterAgent: initFilterModel(),
                show: false,
                realEstate: {},
                agents: []
            }
        },
        validations() {
            return {
                realEstate: {
                    createdBy: {
                        required: required
                    }
                }
            }
        },
        methods: {
            bindAgent() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('admin/e-appraisal/real-estate/bind-agent', this.realEstate).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.realEstate.statusSuccess'),
                            type: 'success'
                        });
                        this.show = false;
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t(res.data.message),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.realEstate.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                })
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filterAgent.search = searchTxt;

                this.filterAgent.province = null;
                this.filterAgent.region = null;

                this.$http.post('user/agent', this.filterAgent)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filterAgent.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filterAgent.search = '';

                this.filterAgent.province = this.realEstate.province ? this.realEstate.province : null;
                this.filterAgent.region = null;

                this.$http.post('user/agent', this.filterAgent)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showRealEstateBindAgentModal', (data) => {
                if (data) {
                   this.realEstate = data;
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>